import { getEquippedFor } from './equipped-cache.js';

// <retro-banner username="...">
//
// Hero-tier-only background layer. Mounts the user's equipped banner
// as a position:absolute inset:0 z-index:0 layer inside the host card,
// behind all other content (avatar, username, profile-effect). Renders
// nothing when no banner is equipped.
//
// Per docs/store-asset-specs.md §3.5, banner is a hero-tier-only
// surface — only mount inside containers with `position: relative`
// and meaningful card dimensions.

class RetroBanner extends HTMLElement {
  static observedAttributes = ['username'];

  connectedCallback() { this._render(); }

  attributeChangedCallback(name, oldVal, newVal) {
    if (oldVal !== newVal && this.isConnected) this._render();
  }

  async _render() {
    const username = this.getAttribute('username');
    if (!username) { this.innerHTML = ''; return; }
    const equipped = await getEquippedFor(username);
    if (!this.isConnected || this.getAttribute('username') !== username) return;

    const url = equipped.banner?.image_url;
    this.innerHTML = '';
    if (!url) return;

    const img = document.createElement('img');
    img.src = url;
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    this.appendChild(img);
  }
}

if (!customElements.get('retro-banner')) {
  customElements.define('retro-banner', RetroBanner);
}
